export const SECRET_KEY = "03325cc049cdb55d0e665222c504005b477c3abab54580a0bd82d729166bbfb8";

export async function signFile(file: File): Promise<string> {
    const arrayBuffer = await file.arrayBuffer();
    const keyBuffer = new TextEncoder().encode(SECRET_KEY);
    
    const key = await crypto.subtle.importKey(
        "raw",
        keyBuffer,
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const signature = await crypto.subtle.sign("HMAC", key, arrayBuffer);
    return Array.from(new Uint8Array(signature))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}



